// extracted by mini-css-extract-plugin
export default {"wrap":"B38GKlzF","row":"UCH6RjSm","diagonal":"NAhbSboo","cellLabel":"BTEnwRau"};